import { DocumentData } from "@angular/fire/firestore";
import { DrinkPosition } from "./drink.position.model";
import { MenuCategory } from "../../category/menu.category.model";

export class DrinkPositionBuilder {
  private _categoryId: string;
  private _position: number;
  constructor() {}

  load(data: DocumentData): DrinkPositionBuilder {
    this._categoryId = data.categoryId;
    this._position = data.position;
    return this;
  }
  edit(position: DrinkPosition): DrinkPositionBuilder {
    this._categoryId = position.categoryId;
    this._position = position.position;
    return this;
  }

  create(category: MenuCategory): DrinkPositionBuilder {
    this._categoryId = category.id;
    this._position = 999;
    return this;
  }

  public get categoryId(): string {
    return this._categoryId;
  }

  public get position(): number {
    return this._position;
  }

  public toJSON = () => ({
    categoryId: this._categoryId,
    position: this._position
  });
}
